function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ToggledFeatureKey } from '@domain-group/fe-allhomes-library';
var auctionResults = {
  id: 'auction-results',
  label: 'Auction Results',
  href: '/auction-results/',
  analyticsEventName: 'Research - Auction Results'
};
var CRE_COMMERCIAL_LINK = 'https://www.commercialrealestate.com.au/for-sale/?bb=-34.67771%2C-35.77593%2C150.18593%2C148.44048%2C15';
var CRE_LEASE_LINK = 'https://www.commercialrealestate.com.au/for-lease/?bb=-34.67771%2C-35.77593%2C150.18593%2C148.44048%2C15';
var CRE_BUSINESS_LINK = 'https://www.commercialrealestate.com.au/business-for-sale/act/?sb=36442%2C18962%2C22242%2C31582%2C60622%2C51272%2C22802';
var primaryNav = [[{
  id: 'SALES_RESIDENTIAL',
  label: 'Buy',
  href: '/sale/'
}, {
  id: 'category-rent',
  label: 'Rent',
  href: '/rent/',
  items: [{
    id: 'RENTAL_RESIDENTIAL',
    label: 'Rent',
    href: '/rent/'
  }, {
    id: 'SHARE_RESIDENTIAL',
    label: 'Share',
    href: '/share/'
  }, {
    id: 'BTR',
    label: 'Build-to-Rent',
    href: '/rent/search?listingtypes=build-to-rent',
    isNew: true,
    toggledFeature: ToggledFeatureKey.BUILD_TO_RENT
  }]
}, {
  id: 'SOLD_RESIDENTIAL',
  label: 'Sold',
  href: '/sold/search'
}, {
  id: 'DEVELOPMENTS_RESIDENTIAL',
  label: 'New Homes',
  href: '/new-homes/'
}, {
  id: 'category-commercial',
  label: 'Commercial',
  href: CRE_COMMERCIAL_LINK,
  items: [{
    id: 'RENTAL_COMMERCIAL',
    label: 'For Lease',
    href: CRE_LEASE_LINK
  }, {
    id: 'SALES_COMMERCIAL',
    label: 'For Sale',
    href: CRE_COMMERCIAL_LINK
  }, {
    id: 'SALES_BUSINESS',
    label: 'Business',
    href: CRE_BUSINESS_LINK
  }]
}], [{
  id: 'sell',
  label: 'Sell',
  href: '/sell'
}, {
  id: 'agents',
  label: 'Find agents',
  href: '/agents/'
}, _objectSpread(_objectSpread({}, auctionResults), {}, {
  showOn: ['mobile', 'tablet']
}), {
  id: 'research',
  label: 'Research',
  href: '/research',
  items: [{
    id: 'property-past-sales',
    label: 'Suburb Profile & Past Sales',
    href: '/research'
  }, _objectSpread(_objectSpread({}, auctionResults), {}, {
    showOn: ['desktop']
  }), {
    id: 'property-report',
    label: 'ACT Property Report',
    href: '/ah/research/property-report'
  }, {
    id: 'glossary',
    label: 'Glossary',
    href: '/ah/research/glossary'
  }]
}, {
  id: 'news-category',
  label: 'News',
  href: '/news/act/',
  items: [{
    id: 'news-canberra',
    label: 'Canberra',
    href: '/news/act/'
  }, {
    id: 'news-latest',
    label: 'News',
    href: '/news/'
  }, {
    id: 'news-industry',
    label: 'Industry',
    href: '/news/act-industry-news'
  }, {
    id: 'news-advice',
    label: 'Advice',
    href: '/advice/'
  }, {
    id: 'news-living',
    label: 'Living',
    href: '/living/'
  }]
}]];
export default primaryNav;